<template>
  <div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('dashboard')">
        <fa icon="home" class="w-4 h-4 mr-2" :class="isUrl('') ? 'text-white' : 'text-shtax-400 group-hover:text-white'" fixed-width />
        <div :class="isUrl('') ? 'text-white' : 'text-shtax-300 group-hover:text-white'">Główna</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="$page.props.can['see clients module']">
      <inertia-link class="flex items-center group py-3" :href="route('clients')">
        <fa icon="user-tie" class="w-4 h-4 mr-2" :class="isUrl('clients') ? 'text-white' : 'text-shtax-400 group-hover:text-white'" fixed-width />
        <div :class="isUrl('clients') ? 'text-white' : 'text-shtax-300 group-hover:text-white'">Klienci</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="$page.props.can['see contracts module']">
      <inertia-link class="flex items-center group py-3" :href="route('contracts')">
        <fa icon="file-contract" class="w-4 h-4 mr-2" :class="isUrl('contracts') ? 'text-white' : 'text-shtax-400 group-hover:text-white'" fixed-width />
        <div :class="isUrl('contracts') ? 'text-white' : 'text-shtax-300 group-hover:text-white'">Umowy</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="$page.props.can['see factures module']">
      <inertia-link class="flex items-center group py-3" :href="route('factures')">
        <fa icon="file-invoice" class="w-4 h-4 mr-2" :class="isUrl('factures') ? 'text-white' : 'text-shtax-400 group-hover:text-white'" fixed-width />
        <div :class="isUrl('factures') ? 'text-white' : 'text-shtax-300 group-hover:text-white'">Def. faktur</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="$page.props.can['see invoices module']">
      <inertia-link class="flex items-center group py-3" :href="route('invoices')">
        <fa icon="file-invoice-dollar" class="w-4 h-4 mr-2" :class="isUrl('invoices') ? 'text-white' : 'text-shtax-400 group-hover:text-white'" fixed-width />
        <div :class="isUrl('invoices') ? 'text-white' : 'text-shtax-300 group-hover:text-white'">Dok. handlowe</div>
      </inertia-link>
    </div>
    <div class="mb-4" v-if="$page.props.can['see invoices module']">
      <inertia-link class="flex items-center group py-3" :href="route('fin_docs')">
        <fa icon="cash-register" class="w-4 h-4 mr-2" :class="isUrl('fin_docs') ? 'text-white' : 'text-shtax-400 group-hover:text-white'" fixed-width />
        <div :class="isUrl('fin_docs') ? 'text-white' : 'text-shtax-300 group-hover:text-white'">
          Dok. finansowe
        </div>
      </inertia-link>
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
